import { useForm, zodResolver } from '@mantine/form'
import Form from 'common/Form'
import NumberWithUnitInput from 'common/inputs/NumberWithUnitInput'
import { useOrderShortages } from 'hooks/shortage'
import { Unit } from 'types/products'
import { orderShortagesSchema } from 'types/schemas'
import { GroupedShortageTableItem } from 'types/shortage'
import { trimFormValues } from 'utils'

type Props = {
  groupedShortage: GroupedShortageTableItem
  totalShortagesAmount: number
  onCancel: () => void
}

type FormValues = {
  amount: number
  unit: Unit
}

export default function OrderShortagesForm({ groupedShortage, totalShortagesAmount, onCancel }: Props) {
  const order = useOrderShortages()
  const form = useForm<FormValues>({
    initialValues: {
      amount: totalShortagesAmount,
      unit: groupedShortage.subRows[0].unit,
    },
    validate: zodResolver(orderShortagesSchema(totalShortagesAmount)),
    transformValues: trimFormValues,
  })

  async function submit(values: FormValues) {
    await order.mutateAsync({
      productId: groupedShortage.product.id,
      feature: groupedShortage.feature,
      size: groupedShortage.size,
      category: groupedShortage.category,
      orderedAmount: values.amount,
      unit: values.unit,
    })
  }

  return (
    <Form onSubmit={submit} form={form} onCancel={onCancel} submitText="Zamów">
      <NumberWithUnitInput
        label="Zamawiana ilość"
        description="Ilość produktu jaką chcesz zamówić. Musi być większa niż suma braków."
        availableUnits={[groupedShortage.subRows[0].unit]}
        form={form}
        withAsterisk
      />
    </Form>
  )
}
